<template>
    <div v-if="isSettingName" class="menu_main__item">
        <div class="menu_main__item_wrapper">
            <div class="menu_main__item_setting_name">
                {{ settingName }}
            </div>
        </div>
    </div>

    <div class="menu_main__item cursor_pointer" :class="classItem" @click.prevent="clickItem">
        <div class="menu_main__item_wrapper">
            <div class="menu_main__item_info_block">
                <div class="menu_main__item_info_block_icon">
                    <svg height="24" width="24" class="cursor_pointer">
                        <use :xlink:href="refSvg"></use>
                    </svg>
                </div>
                <div class="menu_main__item_info_block_text">
                    {{ titleLink }}
                </div>
            </div>
            <div class="menu_main__item_count_rest">
                {{ item.count }}
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "item_header",
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
    emits: [],
    data() {
        return {
        }
    },
    methods: {
        clickItem(){
            EventBus.$emit('click_item_menu_main', this.item);
        }
    },
    computed: {
        isSettingName() {
            if (this.item.settingName !== '') {
                return true;
            }
            return false;
        },
        classItem() {
            if(this.item.isSelect) {
                return {'active': true};
            }
            return {'active': false}
        },
        settingName() {
            if(this.item.settingNameConst){
                return `${this.__t(this.item.settingNameConst)}`;
            }
            return '';
            //return this.item.settingName;
        },
        refSvg() {
            return '/icons/base.svg#' + this.item.name;
        },
        titleLink(){
            if(this.item.const){
                return `${this.__t(this.item.const)}`;
            }
            return '';
        }
    }
}
</script>
